import  React from 'react';
import styles from 'bundle-text:./styles.css';
import 'regenerator-runtime/runtime'

const LoaderButton = ({active = false}) => (
    <React.Fragment>        
        <style>
            {styles}
        </style>
        <svg 
        width="40" 
        height="40" 
        version="1.1"
        className={`circle__loader ${active ? 'active' : ''}`} 
        xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="15" />
        </svg>
    </React.Fragment>
);

export default LoaderButton;